import { ActionPermission } from '../../../../hooks/useDevicesNavigoMachine/types'

export function showByPermission(permission: ActionPermission) {
  return permission !== 'hidden'
}

export function disabledByPermission(permission: ActionPermission) {
  return permission.startsWith('disabled')
}
